import { useCallback } from 'react';
import { useWindowListener } from 'src/hooks/use-window-listener';

export const useInfiniteScroll = ({ cb, disabled, threshold = 100 } : {
    cb: () => void, disabled?: boolean, threshold?: number
}) => {
    const handleScroll = useCallback(() => {
        const scrolledDistance = window.innerHeight + document.documentElement.scrollTop;
        const diff = document.documentElement.offsetHeight - scrolledDistance;
        if (diff > threshold) {
            return;
        }
        cb();
    }, [cb, threshold]);

    useWindowListener('scroll', handleScroll, 10, disabled);
};
